import Button from '../../../components/CustomButtons/ButtonTS';
import { NavLink } from 'react-router-dom';
import React from 'react';
import Timeline from '@material-ui/icons/Timeline';
import { connect } from 'react-redux';
import { setCurrentNodeID } from '../../stores/actions/actions';
import { INode } from '../../helpers/interfaces';
import Tooltip from "@material-ui/core/Tooltip";


interface IDetailsIconProps {
	show: boolean;
	node: INode;
	setCurrentNodeID(nodeId: number): void;
}

export const DetailsIcon = (props: IDetailsIconProps) => {
	const { show, node, setCurrentNodeID } = props;
	if (!show) {
		return null;
	}
	return (
		<NavLink to={`/devices/${node.id}/graph`}>
            <Tooltip title="Go to graphs">
                <div>
                    <Button color='info' simple justIcon onClick={() => setCurrentNodeID(node.id)} data-testid='detailsIcon'>
                        <Timeline />
                    </Button>
                </div>
            </Tooltip>
        </NavLink>
	);
};

const actions = { setCurrentNodeID };

export default connect(null, actions)(DetailsIcon);
